const stringHash = require("string-hash");

// 获取hash名称
export function getNumberName (name) {
  return stringHash(name.toString())
}
